module.exports = __webpack_public_path__ + "img/settings.fb49b861.svg";